import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

import { Image } from '@unimed-fesp/components';

import { Container, AutenticacaoStructure, ImageStructure } from './styles';

import SectionHeader from '../../components/atoms/SectionHeader';

import UnimedLogo from '../../assets/images/login/logo-unimed-fesp.svg';

import LoginPart from './LoginPart';
import RedefinirSenha from './RedefinirSenha';

function Login() {
  const { path } = useRouteMatch();

  return (
    <Container>
      <AutenticacaoStructure>
        <Image src={UnimedLogo} name="Unimed Logo" />
        <SectionHeader
          sectionName="movcad"
          subtextSectionName="movimentações cadastrais"
        />
        <Switch>
          <Route exact path={`${path}/redefinir-senha`}>
            <RedefinirSenha />
          </Route>
          <Route exact path={`${path}/`}>
            <LoginPart />
          </Route>
        </Switch>
      </AutenticacaoStructure>
      <ImageStructure />
    </Container>
  );
}

export default Login;
